import styles from "./styles.module.css";

export default function Toggle({ tab, setTab }) {
  return (
    <div className={styles.toggle}>
      <div onClick={() => setTab("blocks")} className={styles.toggleText}>
        BLOCKS
      </div>
      <div onClick={() => setTab("layers")} className={styles.toggleText}>
        LAYERS
      </div>
      <div
        onClick={() => setTab(tab === "blocks" ? "layers" : "blocks")}
        className={`${styles.button} ${styles[tab]}`}
      />
    </div>
  );
}
